import React from 'react';
import styles from './styles.module.scss';

import {Hero} from '../../../../components/LandingComponents/Hero/Hero';
import {Features} from '../../../../components/LandingComponents/Features/Features';
import {Solutions} from '../../../../components/LandingComponents/Solutions';
import {WhyUs} from '../../../../components/LandingComponents/WhyUs';
import {TechnologyOverview} from '../../../../components/LandingComponents/TechnologyOverview';
import {Footer} from '../../../../components/LandingComponents/Footer/Footer';
import {Contact} from '../../../../components/LandingComponents/Contact/Contact';

const Desktop = ({handleClick, formData, onChange, onSubmit, pageStatus}) => {
  return (
    <>
      <div className={styles.container}>
        <Hero />
        <Features />
        <Solutions />
        <TechnologyOverview />
        <WhyUs />
        <Contact
          formData={formData}
          onChange={onChange}
          onSubmit={onSubmit}
          pageStatus={pageStatus}
        />
        <Footer />
      </div>
    </>
  );
};

export default Desktop;
